import type { MagentoPrice } from "@jti/magento-types";

export type Tax = {
  amount: MagentoPrice;
  label: string;
  rate?: number;
};

export type OrderDetailsTax = {
  rate: number;
  title: string;
  amount: MagentoPrice;
};
